module.exports = __webpack_public_path__ + "components/page-header/static/mountain-badge--light-0c3689ae3aad6e3b3473aaf4405126af.svg";